// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".none[data-v-004b5b1f]{width:100%;height:calc(100% - 20px);line-height:100%;position:absolute;left:0;top:30px;padding-top:150px;background:#f5f5f5;text-align:center}", ""]);
// Exports
module.exports = exports;
